import React from 'react';

import { useMutation } from '@tanstack/react-query';
import { Button } from '@eas/common-web';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

const reindexAll = () =>
  fetch('/api/tapis/reindex', {
    method: 'POST',
  });

const useReindexAll = () => useMutation(reindexAll);

export function CustomDeveloperTools() {
  const { mutate, isLoading, isSuccess, isError } = useReindexAll();

  return (
    <Grid container spacing={0} direction="column" alignItems="center">
      <Box height={50} />
      <Grid item>
        <Button
          contained
          disabled={isLoading}
          label={isLoading ? 'Reindexování...' : 'Reindexovat'}
          onClick={() => mutate()}
        />
        {isSuccess && <p>Reindexování úspěšně dokončeno.</p>}
        {isError && <p>Reindexování selhalo.</p>}
      </Grid>
    </Grid>
  );
}
